'use strict';

/**
 * WalletModule — wallet CRUD and fund-flow operations.
 */
class WalletModule {
  constructor(client) {
    this._c = client;
  }

  getWallet()              { return this._c.rawGet('/api/v1/wallet'); }
  getBalance()             { return this._c.rawGet('/api/v1/wallet/balance'); }

  getStatement(params) {
    const qs = params ? `?${new URLSearchParams(params)}` : '';
    return this._c.rawGet(`/api/v1/wallet/statement${qs}`);
  }

  /** Admin: credit / debit a wallet */
  adjustBalance(body)      { return this._c.rawPost('/api/v1/wallet/adjust', body); }

  /** Transfer funds between wallets */
  transfer(body)           { return this._c.rawPost('/api/v1/wallet/transfer', body); }

  listWallets(params) {
    const qs = params ? `?${new URLSearchParams(params)}` : '';
    return this._c.rawGet(`/api/v1/wallet/list${qs}`);
  }
}

module.exports = { WalletModule };
